import type { WarrantyType } from '@fixflow/shared-types';
import { cn } from '@/lib/utils.js';

type WarrantyFieldProps = {
  type: WarrantyType;
  days: number | '';
  onTypeChange: (type: WarrantyType) => void;
  onDaysChange: (days: number | '') => void;
  disabled?: boolean;
  className?: string;
  /** Allow clearing to “inherit” by omitting none/days - not used by default */
  label?: string;
};

/**
 * Radio group: None | [N] days | Lifetime
 */
export function WarrantyField({
  type,
  days,
  onTypeChange,
  onDaysChange,
  disabled,
  className,
  label = 'Warranty',
}: WarrantyFieldProps) {
  return (
    <fieldset className={cn('space-y-2', className)} disabled={disabled}>
      <legend className="text-sm font-semibold text-slate-800">{label}</legend>
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <label className="inline-flex items-center gap-2">
          <input
            type="radio"
            name="warranty-type"
            checked={type === 'none'}
            onChange={() => onTypeChange('none')}
          />
          None
        </label>
        <label className="inline-flex items-center gap-2">
          <input
            type="radio"
            name="warranty-type"
            checked={type === 'days'}
            onChange={() => onTypeChange('days')}
          />
          <input
            type="number"
            min={1}
            className="w-16 rounded-lg border border-slate-300 px-2 py-1 disabled:bg-slate-100"
            disabled={type !== 'days' || disabled}
            value={type === 'days' ? days : ''}
            onChange={(e) => {
              const n = e.target.value === '' ? '' : Number(e.target.value);
              onDaysChange(n === '' || Number.isFinite(n) ? n : '');
            }}
            onFocus={() => onTypeChange('days')}
          />
          days
        </label>
        <label className="inline-flex items-center gap-2">
          <input
            type="radio"
            name="warranty-type"
            checked={type === 'lifetime'}
            onChange={() => onTypeChange('lifetime')}
          />
          Lifetime
        </label>
      </div>
    </fieldset>
  );
}
